export const KNM_HISTORY_FIELD_TEXT_PREFIX = 'Значение поля';
